// 计算api接口的基本地址
let hostname = location.hostname;
hostname = hostname.substring(hostname.indexOf('.'));
let appHost = `${location.protocol}//api${hostname}`;
const baseUrl = `${appHost}/zmtx/`;
import axios from 'axios'

//患者是否登录
export function checkin(data) {
    return axios.post(`${baseUrl}patient/check-in`, data)
}

//注册
export function Login(data) {
    return axios.post(`${baseUrl}patient/login`, data)
}

//退出
export function Logout(data) {
    return axios.post(`${baseUrl}patient/logout`, data)
}

//验证码
export function SendVerifyCode(data) {
    return axios.post(`${baseUrl}patient/sendverifycode`, data)
}

//获取知情同意书
export function PatientConfig(data) {
    return axios.post(`${baseUrl}patient/config`, data)
}

//上传知情同意书
export function UploadContract(data) {
    return axios.post(`${baseUrl}patient/upload-contract`, data)
}

//查询知情同意书信息
export function TypeCheckItem(data) {
    return axios.post(`${baseUrl}pap-audit/type-check-item`, data)
}

//身份证ocr识别
export function IdcardOcr(data) {
    return axios.post(`${baseUrl}patient/idcard-ocr`, data)
}

//患者申请
export function Apply(data) {
    return axios.post(`${baseUrl}patient/apply`, data)
}

//患者重复入组
export function ReApply(data) {
    return axios.post(`${baseUrl}patient/reapply`, data)
}


//获取省
export function GetProvince(data) {
    return axios.post(`${baseUrl}default-audit/get-province`, data)
}

//获取城市
export function GetCity(data) {
    return axios.post(`${baseUrl}default-audit/get-city`, data)
}

//获取医院
export function GetHospital(data) {
    return axios.post(`${baseUrl}default-audit/get-hospitals`, data)
}

//获取医生
export function GetDoctor(data) {
    return axios.post(`${baseUrl}default-audit/get-doctors`, data)
}

//获取药房
export function GetDrugstore(data) {
    return axios.post(`${baseUrl}default-audit/get-drugstores`, data)
}

//获取援助方式
export function GetMode(data) {
    return axios.post(`${baseUrl}default-audit/get-modes`, data)
}

//获取患者信息
export function GetPatient(data) {
    return axios.post(`${baseUrl}pap-audit/get-patient`, data)
}

//获取审核项状态
export function CheckItemStatus(data) {
    return axios.post(`${baseUrl}pap-audit/check-item-status`, data)
}

//获取审核项
export function GetCheckItem(data) {
    return axios.post(`${baseUrl}pap-audit/get-check-items`, data)
}

//上传审核项
export function UploadCheckItem(data) {
    return axios.post(`${baseUrl}pap-audit/upload-check-item`, data)
}

//上传后续审核项
export function FollowUpload(data) {
    return axios.post(`${baseUrl}pap-audit/follow-upload`, data)
}

//上传后续审核项
export function UploadRecipel(data) {
    return axios.post(`${baseUrl}patient/upload-recipel`, data)
}

//提交审核材料后更新患者状态
export function UploadPatientStatus(data) {
    return axios.post(`${baseUrl}pap-audit/update-patient-status`, data)
}

//删除审核项
export function deleteCheckItem(data) {
    return axios.post(`${baseUrl}pap-audit/delete-check-item`, data)
}

//获取领药单材料
export function receiveItem(data) {
    return axios.post(`${baseUrl}pap-audit/receive-item`, data);
}

//上传图片
export function DownloadImage(data) {
    // console.log(data,'data')
    return axios.get(`${baseUrl}wechat/download-image`, data)
}


//删除图片
export function DeleteImg(data) {
    return axios.post(`${baseUrl}wechat/delete-img`, data)
}

// 查询患者申请进度
export function QueryApplyProgress(data) {
    return axios.post(`${baseUrl}pap-audit/query-apply-progress`, data)
}

//领药信息
export function GetReceiveInfo(data) {
    return axios.post(`${baseUrl}pap-audit/get-receive-info`, data)
}

//领取单
export function GetRreceives(data) {
    return axios.post(`${baseUrl}pap-audit/get-receives`, data);
}

//添加/更新代领药人
export function UpdateAgent(data) {
    return axios.post(`${baseUrl}pap-audit/update-agent`, data)
}

//删除代领药人
export function DeleteAgent(data) {
    return axios.post(`${baseUrl}agent/delete-agent`, data)
}

//代领药人列表
export function Agents(data) {
    return axios.post(`${baseUrl}pap-audit/agents`, data)
}

//查询快件
export function QueryExpress(data) {
    return axios.post(`${baseUrl}pap-audit/express-query`, data)
}
//查询快递
export function getExpressInfov1(data) {
    return axios.post(`${baseUrl}pap/getExpressInfov1`, data)
}

//进度
export function GetPredict(data) {
    return axios.post(`${baseUrl}pap/get-predict`, data)
}

//获取单页面
export function pageInfo(data) {
    return axios.get(`${baseUrl}pages`, data)
}

//领药显示材料
export function getShowItem(data) {
    return axios.post(`${baseUrl}pap-audit/get-show-item`, data)
}

//获取多页面
export function articles(data) {
    return axios.get(`${baseUrl}articles`, data)
}

//获取下载列表
export function documents(data) {
    return axios.get(`${baseUrl}documents`, data)
}


//开启新阶段
export function newPhase(data) {
    return axios.post(`${baseUrl}pap-audit/new-phase`, data)
}



//转诊申请查询
export function ApplyQuery(data) {
    return axios.post(`${baseUrl}pap-audit/referral-apply-query`, data)
}


//删除转诊申请图片
export function AttachDel(data) {
    return axios.post(`${baseUrl}pap-audit/referral-attach-del`, data)
}

//转诊申请提交
export function ReferralApply(data) {
    return axios.post(`${baseUrl}pap-audit/referral-apply`, data)
}

//发送邮箱
export function sendEmail(data) {
    return axios.post(`${baseUrl}document/send-email`, data)
}

//查询代领药人
export function SubstituteQuery(data) {
    return axios.post(`${baseUrl}pap-audit/substitute-query`, data)
}

//代领药人申请
export function Substitute(data) {
    return axios.post(`${baseUrl}pap-audit/substitute`, data)
}

//更换代领药人
export function SetUpSubstitube(data) {
    return axios.post(`${baseUrl}pap-audit/set-up-substitute`, data)
}

//代领药人上传材料
export function SubstituteUpload(data) {
    return axios.post(`${baseUrl}pap-audit/substitute-upload`, data)
}

//删除代领药人材料
export function SubstituteAttachDelete(data) {
    return axios.post(`${baseUrl}pap-audit/substitute-attach-delete`, data)
}

//删除代领药人
export function SubstituteDel(data) {
    return axios.post(`${baseUrl}pap-audit/substitute-del`, data)
}

// 获取人脸识别
export function LiveNess(data) {
    return axios.post(`${baseUrl}patient/liveness`, data)
}

// 提交人脸视频对比
export function livenessCompare(data) {
    return axios.post(`${baseUrl}patient/liveness-compare`, data)
}

// 拍照上传
export function patientFaceApply(data) {
    return axios.post(`${baseUrl}patient/patient-face-apply`, data)
}

// 查询人脸人工审核结果
export function checkFace(data) {
    return axios.post(`${baseUrl}patient/check-face`, data)
} 

//获取志愿者
export function getVolunteers(data) {
    return axios.post(`${baseUrl}default-audit/get-volunteers`, data);
} 

//获取合作机构数据
export function getMapCount(data) {
  return axios.post(`${baseUrl}pap/get-map-count`, data);
} 

//获取预测单解锁材料
export function PredictUnlockQuery(data) {
    return axios.post(`${baseUrl}pap-audit/predict-unlock-query`, data)
}

//预测单解锁材料上传
export function PredictUnlockItemUpload(data) {
    return axios.post(`${baseUrl}pap-audit/predict-unlock-item-upload`, data)
}

//更新预测单解锁材料上传状态
export function PredictUnlockUpload(data) {
    return axios.post(`${baseUrl}pap-audit/predict-unlock-upload`, data)
}

//删除预测单解锁材料
export function PredictUnlockAttachDel(data) {
    return axios.post(`${baseUrl}pap-audit/predict-unlock-attach-del`, data)
}

//获取隐私政策
export function getPrivacyConfig(data) {
    return axios.get(`${baseUrl}patient/get-privacy-config`, data)
}
    
//阅读隐私政策
export function privacyRead(data) {
    return axios.post(`${baseUrl}patient/privacy-read`, data)
}
    




/*------医生通道模块api--------*/

//医生登陆
export function DoctorLogin(data) {
    return axios.post(`${baseUrl}doctor/login`, data)
}

//医生退出
export function DoctorLogout(data) {
    return axios.post(`${baseUrl}doctor/logout`, data)
}

//同步医生公益平台医生信息
export function SyncErecipelDoctor(data) {
    return axios.post(`${baseUrl}doctor/sync-erecipel-doctor`, data)
}

//获取医生信息
export function GetDoctorDetail(data) {
    return axios.get(`${baseUrl}doctor/get-detail`, data)
}

//医生信息页获取验证码
export function SendDocVerifycode(data) {
    return axios.post(`${baseUrl}sms/sendverifycode`, data)
}

//获取平台医生的医院列表
export function GetDoctorHospital(data) {
    return axios.post(`${baseUrl}pap/get-admin-hospitals`, data)
}

//获取平台医生的职称列表
export function GetDepartmentJob(data) {
    return axios.get(`${baseUrl}config/get-department-job`, data)
}

//提交医生表单信息
export function SubmitDoctorInfo(data) {
    return axios.post(`${baseUrl}doctor/complete`, data)
}

//删除医生上传的材料图片
export function RemoveDocInfoAttach(data) {
    return axios.post(`${baseUrl}doctor-attach/remove`, data)
}

//获取👩‍⚕️信息合成的备案表实例图片
export function GetDocRecordExample(data) {
    return axios.get(`${baseUrl}doctor-attach/get-record-example-image`, data)
}

//获取医生的理解备忘录
export function GetMemo(data) {
    return axios.get(`${baseUrl}config/get-memo`, data)
}

//获取考试的试题
export function GetExamQuestions(data) {
    return axios.get(`${baseUrl}exam/get-questions`, data)
}

//获取考试的视频
export function GetExamVideos(data) {
    return axios.get(`${baseUrl}videos`, data)
}

//获取考试的视频
export function SubmitDocExamRecord(data) {
    return axios.post(`${baseUrl}exam-record/exam`, data)
}

//获取考试的视频
export function DoctorReadRecord(data) {
    return axios.post(`${baseUrl}doctor/read-record?id=${data}`)
}

//获取医生备案表历史图片
export function GetDocRecordAttach(data) {
    return axios.get(`${baseUrl}record-attach/get-records`, data)
}

//提交医生备案表图片
export function SubmitDocRecordAttach(data) {
    return axios.post(`${baseUrl}record-attach/submit`, data)
}

//删除医生备案表图片
export function RemoveDocRecordAttach(data) {
    return axios.post(`${baseUrl}record-attach/remove`, data)
}

//获取医生签收表实例图片
export function GetDocSignExample(data) {
    return axios.get(`${baseUrl}sign-attach/get-example-image`, data)
}
//获取医生签收表历史图片
export function GetDocSignAttach(data) {
    return axios.get(`${baseUrl}sign-attach/get-records`, data)
}

//提交医生签收表图片
export function SubmitDocSignAttach(data) {
    return axios.post(`${baseUrl}sign-attach/submit`, data)
}

//删除医生签收表图片
export function RemoveDocSignAttach(data) {
    return axios.post(`${baseUrl}sign-attach/remove`, data)
}

//阅读隐私政策
export function privacyReadDoc(data) {
    return axios.post(`${baseUrl}doctor/privacy-read`, data)
}

/*------医生通道模块api--------*/
